import cx from 'classnames';
import React from 'react';

import { useLocationContext } from '../context/LocationContext';

type Props = {
  ctaText: string;
};

export default function ModalCta({ ctaText }: Props) {
  const { isDeliveryAllowed = true } = useLocationContext();

  return (
    <div
      data-qa="delivery-text"
      data-testid="delivery-text"
      className={cx('pt-32 text-center text-blue-6 tl-header-m s:max-m:px-24', {
        'bg-grey-1 pb-0': isDeliveryAllowed,
        'pb-32': !isDeliveryAllowed
      })}
    >
      {ctaText}
    </div>
  );
}
